import type { ResolvedDateTimeFormat } from "@/shared/datetime";

import type { TickFormatter } from "./timeTicks";

/**
 * Axis labels from the user's datetime preference: the clock honors their
 * 12/24-hour choice; day, month and year labels are short locale forms
 * ("Oct 4", "Oct", "2026") since a full date is too wide for a tick. Every
 * label, and the calendar the ticks align to, is in `format`'s zone.
 */
export function makeTickFormatter(
  format: ResolvedDateTimeFormat,
): TickFormatter {
  const timeZone = format.zone;
  const day = new Intl.DateTimeFormat(undefined, {
    month: "short",
    day: "numeric",
    timeZone,
  });
  const month = new Intl.DateTimeFormat(undefined, {
    month: "short",
    timeZone,
  });
  const year = new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    timeZone,
  });
  return {
    zone: format.zone,
    clock: (date, precision) =>
      format.formatParts(date, { time: precision }).time,
    day: (date) => day.format(date),
    month: (date) => month.format(date),
    year: (date) => year.format(date),
  };
}
